import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import data from "../countryCode/codeData.js";
import { debounce } from "lodash";
import OverflowTooltipText from "@/components/Common/overflow-tooltip-text.vue";
// import clickOutside from 'v-click-outside';
export default {
  components: {
    OverflowTooltipText
  },
  model: {
    prop: "inviteInfo",
    event: "update:inviteInfo"
  },
  props: {
    inviteInfo: {
      type: Object,
      default() {
        return {
          mobileAreaCode: "86",
          account: ""
        };
      }
    },
    showPrepend: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      data,
      isFocused: false,
      currentIndex: 0,
      listHeight: [],
      lock: false,
      lockTimer: null
    };
  },
  computed: {
    // 侧边索引与列表分组统一使用数据源中的 title，确保滚动定位一致。
    indexList() {
      return this.data.map(group => {
        var _group$title;
        return String((_group$title = group.title) !== null && _group$title !== void 0 ? _group$title : "").substring(0, 1);
      });
    }
  },
  methods: {
    onListWrapScroll(event) {
      const container = event.target;
      //   console.log(scrollTop, scrollHeight,clientHeight)
      const containerRect = container.getBoundingClientRect();
      const containerCenterY = containerRect.top + container.offsetHeight / 2;
      // 检测当前下拉视图最中间的元素属于哪个group
      let closestGroup = null;
      let minDistance = Infinity;
      const groups = container.querySelectorAll(".index-group");
      for (const group of groups) {
        const groupRect = group.getBoundingClientRect();
        const groupCenterY = groupRect.top + groupRect.height / 2;
        const distance = Math.abs(groupCenterY - containerCenterY);
        if (distance < minDistance) {
          minDistance = distance;
          closestGroup = group;
        }
      }
      if (closestGroup && !this.lock) {
        this.currentIndex = closestGroup.id;
      }
    },
    setLock() {
      clearTimeout(this.lockTimer);
      this.lockTimer = null;
      //   console.log("上锁");
      this.lock = true;
      this.lockTimer = setTimeout(() => {
        // console.log("解锁");
        this.lock = false;
      }, 1000);
    },
    scrollTo(id) {
      debounce(() => {
        const element = this.$refs[id][0];
        this.setLock();
        element.scrollIntoView({
          behavior: "smooth"
        });
        this.currentIndex = id;
      }, 100)();
    },
    clickItem(item) {
      // this.inviteInfo.mobileAreaCode = item.id;
      this.$emit("update:inviteInfo", {
        ...this.inviteInfo,
        mobileAreaCode: item.id
      });
      this.isFocused = false;
    },
    handleClick() {
      this.isFocused = !this.isFocused;
    },
    onClickOutside(event) {
      if (event.target.id === "area-code-input") return;
      this.isFocused = false;
    },
    changeAccount(event) {
      let {
        value
      } = event.target;
      this.$emit("update:inviteInfo", {
        ...this.inviteInfo,
        account: value.toLowerCase()
      });
    }
  }
};